/**
 * Example dataset for first-time visitors.
 * Represents shaft diameter measurements (mm) from a machining process.
 * Deliberately slightly non-normal (right skew) so the distribution-fitting
 * logic is exercised and the result is interesting rather than trivially normal.
 */
const EXAMPLE_MEASUREMENTS = [
    25.012, 24.998, 25.003, 25.021, 24.995,
    25.008, 25.015, 24.991, 25.006, 25.019,
    24.984, 25.027, 25.002, 25.011, 24.997,
    25.033, 24.989, 25.014, 25.007, 24.993,
    25.018, 25.004, 24.979, 25.025, 25.009,
    25.001, 25.016, 24.987, 25.031, 25.005,
    24.994, 25.022, 25.010, 24.982, 25.017,
    25.038, 24.996, 25.013, 25.003, 24.990,
    25.028, 25.007, 24.985, 25.020, 25.011,
    24.999, 25.024, 25.006, 24.978, 25.015,
];

const exampleDataset = {
    description: 'Shaft Diameter — Example Data',
    usl: 25.050,
    lsl: 24.950,
    subgroupSize: 1,
    values: EXAMPLE_MEASUREMENTS.map(v => [null, v]),
};

export default exampleDataset;
